// extracted by mini-css-extract-plugin
module.exports = {"resultPage":"Page_resultPage__2fZRw","jobDetailsContainer":"Page_jobDetailsContainer__Rd881","resultSidebar":"Page_resultSidebar__3BNG2"};